import { Button, ChevronDownIcon, Popover, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import { chatMetadataStore } from '../../../../../../../../Chatbot/ChatStores/ChatMetadataStore';
import { previewStore } from '../../../../../LearningCollectionPreviewStore';

interface Props {
  showCreateWithoutPublishing?: boolean;
}

function OtherCreateOptions({ showCreateWithoutPublishing = true }: Props) {
  const createWithoutPublishingButtonText = () => {
    switch (chatMetadataStore.assistantRole) {
      case 'default':
        return <T kind="Create without Publishing" />;
      case 'coach':
        return <T kind="Save for Later" />;
    }
  };

  const saveAndEditButtonText = () => {
    switch (chatMetadataStore.assistantRole) {
      case 'default':
        return <T kind="Save & Switch to Manual Editing" />;
      case 'coach':
        return <T kind="Switch to Editor" />;
    }
  };

  return (
    <Popover
      trigger="click"
      placement="left"
      className="!top-[3.5rem] !left-11"
      children={() => (
        <>
          {showCreateWithoutPublishing && (
            <Typography
              className="cursor-pointer pb-3"
              onClick={() => previewStore.startCreating()}
            >
              {createWithoutPublishingButtonText()}
            </Typography>
          )}
          <Typography className="cursor-pointer" onClick={() => previewStore.startSaveAndEditing()}>
            {saveAndEditButtonText()}
          </Typography>
        </>
      )}
      renderTrigger={(ref, getReferenceProps) => (
        <Button
          ref={ref}
          {...getReferenceProps()}
          startContent={<ChevronDownIcon color="white" size="sm" />}
          className="rounded-s-none h-[38px] p-2.5"
          aria-label="More options"
        />
      )}
    />
  );
}

export default observer(OtherCreateOptions);
